export const ADMIN_GAMER_EXPORT_CONFIG = {
  LIST_HEADERS: [ "Date of Transaction", "Item", "Amount", "Mode", "Status", "Valid From", "Valid To" ],
  LIST_ENTITY_KEYS: [ "transactionDate", "item", "amount", "mode", "status", "validFromDate", "validToDate" ],
  EXPORT_FILE_NAME: "gamer-billing-txn-history.csv",
};
